module.exports = __webpack_public_path__ + "static/media/blue-gc-50x50.1e8011d8.png";